<!--
 * @Author: DY
 * @Date: 2020-07-08 10:43:09
 * @LastEditTime: 2020-07-09 15:12:39
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \JT_Web_dev\src\views\contractControl\earlyWarning.vue
-->
<template>
    <div style="background:#000;">
        <div class="earlyWarning">
            <div class="earlyWarningContant">
                <div class="earlyWarningInfo">
                    <dl>
                        <dt>预警信息</dt>
                        <dd>
                            <p>预警时间：2020-6-26 00:00:00</p>
                            <p>结算期次：第13期</p>
                            <p>结算时间：2020-6-15</p>
                            <p>付款截止时间：2020-6-25</p>
                        </dd>
                    </dl>
                    <ul>
                        <li>
                            <h5>本期应收(万元)</h5>
                            <p>142.86</p>
                        </li>
                        <li>
                            <h5>本期实收(万元)</h5>
                            <p>142.86</p>
                        </li>
                        <li>
                            <h5>本期欠款(万元)</h5>
                            <p>142.86</p>
                        </li>
                        <li>
                            <h5>授信金额(万元)</h5>
                            <p>142.86</p>
                        </li>
                        <li>
                            <h5>差值(万元)</h5>
                            <p>142.86</p>
                        </li>
                        <li>
                            <h5>预警金额(万元)</h5>
                            <p>142.86</p>
                        </li>
                    </ul>
                </div>
                <div class="earlyWarningReason">
                    <h3>
                        <i class="iconfont iconbianji1"></i>
                        预警原因描述：
                    </h3>
                    <p>上一个结算期应收142.86万元，实收125万元，本期欠款17.86万元，比最大授信金额20万元仅差2.14万元，已经低于预警金额4万元，所以预警提醒。</p>
                </div>
                <footer>
                    <button @click="Close">
                        关闭
                    </button>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    // 预警提醒
    name: 'early-warning',
    components: {},
    props: {},
    data() {
        return {
        };
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {},
    destroyed() {},
    methods: {
        Close() {
            this.$parent.hide();
        },
    },
};
</script>
<style lang="stylus" scoped>
.earlyWarning
    display inline-block
    width:auto;
    height:660px;
    padding 10px
    position relative
    background: rgba(255,255,255,0.5);
    .earlyWarningContant
        width 100%
        height 100%
        background #fff
        .earlyWarningInfo
            border-bottom 1px solid #F0F0F0
            padding 40px 40px 10px 40px
            dl
                dt
                    font-size 20px
                    color #333
                dd
                    overflow hidden
                    margin 20px 0
                    p
                        float left
                        font-size 16px
                        line-height 40px
                        background #F5F6F8
                        color #333
                        padding 0 10px
                        margin-right 10px
                        &:last-child
                            margin-right 0
            ul
                overflow hidden
                li
                    float left
                    width 120px
                    height 120px
                    text-align center
                    margin-right 20px
                    margin-bottom 10px
                    background rgba(85,136,241,0.1);
                    h5
                        font-size 14px
                        color #333
                        margin 30px 0 15px 0
                    p
                        font-family technology
                        font-size 28px
                        color #5588F1
                    &:nth-of-type(4)
                        background rgba(33,189,204, 0.1);
                        p
                            color #21BDCC
                    &:nth-of-type(5)
                        background rgba(250,132,54, 0.1);
                        p
                            color #FA8436
                    &:last-child
                        margin-right 0
                        background rgba(235,101,111, 0.1)
                        p
                            color #EB656F

        .earlyWarningReason
            padding 10px 40px 40px 40px
            h3
                width 172px
                height 42px
                border 1px solid #D6000F
                color #D6000F
                font-size 18px
                line-height 40px
                text-align center
                margin 10px 0
            p
                width 820px
                font-size 16px
                line-height 36px
                color #333
        footer
            text-align center
            position absolute
            bottom 30px
            left 0
            width 100%
            button
                border 2px solid #1577D2
                background #fff
                width 184px
                height 44px
                font-size 20px
                color #1577D2
                cursor pointer
</style>